import { render, staticRenderFns } from "./PlanningDetailQuoteView.vue?vue&type=template&id=ba35f8c0&scoped=true"
import script from "./PlanningDetailQuoteView.vue?vue&type=script&lang=ts"
export * from "./PlanningDetailQuoteView.vue?vue&type=script&lang=ts"
import style0 from "./PlanningDetailQuoteView.vue?vue&type=style&index=0&id=ba35f8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__ejs@3.1._76e9b4b2772e69f80f08b9c9843f568a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35f8c0",
  null
  
)

export default component.exports